import { useEffect } from 'react';
import { useQueryParam, NumberParam, withDefault } from 'next-query-params';
import { useAtom } from 'jotai';
import { currentPageAtom } from 'global/store';
import { useRouter } from 'next/router';

export default function usePagination() {
  const [currentPage, setCurrentPage] = useAtom(currentPageAtom);
  const router = useRouter();

  const [pageQuery, setPageQuery] = useQueryParam(
      'p',
      withDefault(NumberParam, currentPage)
  );

  useEffect(() => {
    // Sync query param with the current page state
    if (currentPage === 1) {
      // Remove 'p' from query if on the first page
      const { p, ...rest } = router.query;
      router.replace(
          { pathname: router.pathname, query: rest },
          undefined,
          { shallow: true }
      );
    } else {
      // Update 'p' query param
      setPageQuery(currentPage);
    }
  }, [currentPage]);

  useEffect(() => {
    // Sync state with the query param
    setCurrentPage(pageQuery);
  }, [pageQuery]);

  return pageQuery;
}